__turbopack_context__.v({
  "inner": "vH7eQG_inner",
  "rect": "vH7eQG_rect",
  "root": "vH7eQG_root",
  "svg": "vH7eQG_svg",
  "text": "vH7eQG_text",
});
